import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Constants } from "../../../CommonMethhods/Constants";
import { Dashboard_Client_Report } from "../../../Configuration/API_URL";
import AgingReportTable from "../../../Components/ReportTables/AgingReportTable";
import Loader from "../../../Components/Common/Loader";
import SmallLoader from "../../../Components/Common/smallLoader";
import {
  AESEncryption,
  ApiResDecrypt,
} from "../../../CommonMethhods/CommonMethods";

function AgingReportNew() {
  const storeToken = localStorage.getItem("ssoToken");
  const [serverError, setServerError] = useState("");
  const [dataResponse, setDataResponse] = useState("");
  const [loader, setLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  // const [gridError, setGridError] = useState("");

  const [clientCodeStorage, setClientCode] = useState(
    localStorage.getItem("clientCode")
  );
  const ClientId2 = localStorage.getItem("ClientId2");

  const getAgingReport = async (clientCode, fileType) => {
    setLoader(true);
    if (fileType === "excel") {
      setSmallLoaderExcel(true);
      setSmallLoaderPdf(false);
      setLoader(false);
    } else if (fileType === "pdf") {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(true);
      setLoader(false);
    } else {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
    }
    let payloadValue = {
      clientCode: clientCode || ClientId2,
      stockName: "",
      fileType: fileType,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axios.post(
        Dashboard_Client_Report.Aging_Report_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getDetails?.data);

      if (response?.status === 0) {
        if (fileType === "grid") {
          setDataResponse(response?.data);
        } else if (fileType === "excel") {
          window.open(response?.data, "_self", "noopener,noreferrer");
        } else if (fileType === "pdf") {
          window.open(response?.data, "_blank", "noopener,noreferrer");
        }
      } else {
        setDataResponse([]);
        if (fileType === "grid") {
          setServerError("Aging details does not exist.");
        } else if (fileType === "excel") {
          toast.error("Aging Report does not exist.");
        } else if (fileType === "pdf") {
          toast.error("Aging Report does not exist.");
        }
      }
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setServerError("Something went wrong, Please try again later.");
      if (fileType === "excel") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (fileType === "pdf") {
        toast.error("Something went wrong, Please try again later.");
      }
    }
  };

  useEffect(() => {
    if (clientCodeStorage || ClientId2) {
      getAgingReport(clientCodeStorage, "grid");
    }
  }, []);

  const handleOnClick = (e) => {
    if (e.target.value) {
      getAgingReport(clientCodeStorage, e.target.value);
    }
  };

  return (
    <>
      <div
        className="tab-pane fade show active"
        id="aging-report"
        role="tabpanel"
        aria-labelledby="aging-report"
      >
        <div className="reports-date-filter">
          <button
            className="generate-button excel-btn"
            value="excel"
            onClick={handleOnClick}
          >
            {smallLoaderExcel ? (
              <div>
                <SmallLoader />
              </div>
            ) : (
              <>
                <span className="icon-excelsvg"></span>
                {Constants.Excel}
              </>
            )}
          </button>
          <button
            className="generate-button pdf-btn"
            value="pdf"
            onClick={handleOnClick}
          >
            {smallLoaderPdf ? (
              <div>
                <SmallLoader />
              </div>
            ) : (
              <>
                <span className="icon-pdfsvg"></span>
                {Constants.PDF}
              </>
            )}
          </button>
        </div>
      </div>
      {loader ? (
        <div className="loader-alignment">
          <Loader />
        </div>
      ) : dataResponse ? (
        <div>
          <AgingReportTable singleListing={dataResponse} />
        </div>
      ) : (
        ""
      )}
      {serverError && <h4 className="report-error-message">{serverError}</h4>}
    </>
  );
}

export default AgingReportNew;
